import barba from '@barba/core'
import common from './routes/common'

export default {
  init(router, footprint) {
    // Initialize
    // ==========
    barba.init({
      timeout: 10000,
      transitions: [{
        beforeLeave() {
          // 各ページスクリプトの beforeLeave （自前で定義したイベント）を呼ぶ
          common.fireEvent('beforeLeave')
        },
        leave({ current }) {
          return new Promise(resolve => {
            $(current.container)
              .fadeOut(200, resolve)
          })
        },
        beforeEnter({ next }) {
          // enterのアニメーションが発生する前にcssを適用するためにafter内ではなくここでクラスの付替をする
          $('body').attr('class', $(next.html).find('#body-classes').attr('class'))
          // 各ページスクリプトの beforeEnter （自前で定義したイベント）を呼ぶ
          common.fireEvent('beforeEnter')
          // Webフォントを再読み込み
          if (FONTPLUS) {
            FONTPLUS.reload()
          } else {
            console.error('FONTPLUS is not defined')
          }
          // クリック跡の初期化
          footprint.init()
        },
        enter({ next }) {
          return new Promise(resolve => {
            $(next.container)
              .hide()
              .fadeIn(600, resolve)
          })
        },
        after({ trigger, next, current }) {
          // Google Analytics
          gtag('config', document.ga_code, {'page_path' : location.pathname});

          // ブラウザのBack/Forwardボタンを使っている時以外はページの先頭に
          if(!['back', 'forward'].includes(trigger)) {
            window.scrollTo(0,0);
          }

          $('html').attr('lang', /^\/en\//.test(next.url.path) ? 'en' : 'ja')

          // 【順番大事！】loadEventsは、bodyのclassを付け替えた後に呼ぶこと
          router.loadEvents() // Fire routes again after new content loaded

          // 言語間の遷移があった場合
          const prevLang = /^\/en\//.test(current.url.path) ? 'en' : 'ja'
          const nextLang = /^\/en\//.test(next.url.path) ? 'en' : 'ja'
          if (prevLang !== nextLang) {
            common.changeGlobalNavHref(nextLang)
          }
        }
      }]
    })
  }
}
